(function (angular) {
  'use strict';

  angular.module('risevision.common.components.userstate')
    .factory('broadcaster', ['$rootScope',
      function ($rootScope) {

        var service = {};

        service.emit = function(event) {
          $rootScope.$broadcast(event);
        };

        service.emitWithParams = function(event, param) {
          $rootScope.$broadcast(event, param);
        };

        service.on = function(watchedEvent, callback) {
          return $rootScope.$on(watchedEvent, callback);
        };

        return service;
      }
    ]);

})(angular);
